/* src/components/MarketingConsentBanner.jsx
 * Consent Mode v2 banner for public auth pages (signup/login).
 */

import React, { useEffect, useState } from 'react';
import {
  isGoogleAdsConfigured,
  getStoredConsentChoice,
  updateMarketingConsent,
  consumeConsentHandoff,
} from '../utils/marketingTracking';
import '../styles/consentBanner.css';

export default function MarketingConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    consumeConsentHandoff();
    if (!isGoogleAdsConfigured()) return;
    if (getStoredConsentChoice()) return;
    setVisible(true);
  }, []);

  if (!visible) return null;

  function handleChoice(granted) {
    updateMarketingConsent(granted);
    setVisible(false);
  }

  return (
    <div className="marketing-consent-banner" role="dialog" aria-label="Cookie consent">
      <div className="marketing-consent-banner-inner">
        <p className="marketing-consent-banner-text">
          We use cookies for ads measurement and remarketing.{' '}
          <a href="https://gocta.ai/privacy">Privacy policy</a>
        </p>
        <div className="marketing-consent-banner-actions">
          <button
            type="button"
            className="marketing-consent-btn marketing-consent-btn-decline"
            onClick={() => handleChoice(false)}
          >
            Decline
          </button>
          <button
            type="button"
            className="marketing-consent-btn marketing-consent-btn-accept"
            onClick={() => handleChoice(true)}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
